import { c as _c } from "react/compiler-runtime";
import { CompanyMemberRole } from "@components/table/members/members-column/role-column/company-member-role";
import { GroupMemberRole } from "@components/table/members/members-column/role-column/group-member-role";
import { ProjectMemberRole } from "@components/table/members/members-column/role-column/project-member-role";
import { Text } from "@flat-ui";
import { formatUserRoleType } from "@utils/data-display";
/** Content to show for role member column */
export function RoleColumn(t0) {
  const $ = _c(20);
  const {
    companyId,
    selectedProject,
    subjectType,
    memberIdentityRole,
    group,
    isReadOnly: t1,
    subjectName,
    member
  } = t0;
  const isReadOnly = t1 === undefined ? false : t1;
  if (subjectType === "project" && selectedProject) {
    const t2 = selectedProject?.id;
    let t3;
    if ($[0] !== companyId || $[1] !== isReadOnly || $[2] !== memberIdentityRole || $[3] !== t2) {
      t3 = <ProjectMemberRole companyId={companyId} projectId={t2} memberIdentityRole={memberIdentityRole} isReadOnly={isReadOnly} location="role-column" />;
      $[0] = companyId;
      $[1] = isReadOnly;
      $[2] = memberIdentityRole;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (subjectType === "workspace" || subjectType === "team") {
    const t2 = subjectType === "team" ? subjectName : undefined;
    const t3 = subjectType === "workspace" ? member : undefined;
    let t4;
    if ($[5] !== companyId || $[6] !== isReadOnly || $[7] !== memberIdentityRole || $[8] !== t2 || $[9] !== t3) {
      t4 = <CompanyMemberRole companyId={companyId} memberIdentityRole={memberIdentityRole} isReadOnly={isReadOnly} variant="borderless" location="role-column" teamName={t2} member={t3} />;
      $[5] = companyId;
      $[6] = isReadOnly;
      $[7] = memberIdentityRole;
      $[8] = t2;
      $[9] = t3;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  if (subjectType === "group" && group) {
    let t2;
    if ($[11] !== companyId || $[12] !== group || $[13] !== isReadOnly || $[14] !== memberIdentityRole) {
      t2 = <GroupMemberRole companyId={companyId} selectedGroup={group} memberIdentityRole={memberIdentityRole} isReadOnly={isReadOnly} location="role-column" />;
      $[11] = companyId;
      $[12] = group;
      $[13] = isReadOnly;
      $[14] = memberIdentityRole;
      $[15] = t2;
    } else {
      t2 = $[15];
    }
    return t2;
  }
  if (subjectType === "activeMembers") {
    let t2;
    if ($[16] !== memberIdentityRole.role) {
      t2 = formatUserRoleType(memberIdentityRole.role);
      $[16] = memberIdentityRole.role;
      $[17] = t2;
    } else {
      t2 = $[17];
    }
    let t3;
    if ($[18] !== t2) {
      t3 = <Text variant="bodyS">{t2}</Text>;
      $[18] = t2;
      $[19] = t3;
    } else {
      t3 = $[19];
    }
    return t3;
  }
  return null;
}